import ReactModal from "react-modal";
import cn from "classnames";

import CrossIcon from "assets/icons/cross.svg?react";

import { ModalProps } from "./Modal.types";

import styles from "./Modal.module.scss";

const Modal = ({
  withCloseIcon = false,
  open = false,
  centered = true,
  className,
  portalClassName,
  children,
  closeTimeoutMS = 300,
  onClose,
  onAfterOpen,
  onAfterClose,
  testId
}: ModalProps) => (
  //@ts-ignore
  <ReactModal
    portalClassName={cn(styles.portal, portalClassName)}
    overlayClassName={cn(styles.overlay, {
      [styles.overlayCentered]: centered,
    })}
    className={cn(styles.modal, className)}
    isOpen={open}
    closeTimeoutMS={closeTimeoutMS}
    bodyOpenClassName={null} 
    onRequestClose={onClose}
    onAfterOpen={onAfterOpen}
    onAfterClose={onAfterClose}
    testId={testId}
  >
    {withCloseIcon && (
      <div className={styles.iconWrapper} onClick={onClose}>
        <CrossIcon className={styles.icon} />
      </div>
    )}
    {children}
  </ReactModal>
);

export default Modal;
